import React from "react";
import { useLang } from "../LanguageContext";

const FAMILY_IMG = "/photos/storia-facciata.jpg";
const DETAIL_IMG = "/photos/storia-cantina-scale.jpg";

export default function Storia() {
  const { t } = useLang();

  return (
    <section
      id="storia"
      data-testid="storia-section"
      className="relative bg-[#F5F2EC] text-[#23211E] py-24 md:py-40 px-6 md:px-10 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.04] grain-overlay pointer-events-none" />

      <div className="max-w-[1400px] mx-auto grid grid-cols-12 gap-8 md:gap-12 relative">
        <div className="col-span-12 md:col-span-5 md:sticky md:top-32 self-start reveal-on-scroll">
          <p className="text-[11px] uppercase tracking-[0.35em] text-[#B85532] mb-6">
            {t.storia.eyebrow}
          </p>
          <h2
            data-testid="storia-title"
            className="font-serif text-4xl md:text-6xl leading-[0.95] tracking-tight whitespace-pre-line"
          >
            {t.storia.title}
          </h2>

          <div className="mt-10 aspect-[16/9] w-full max-w-md overflow-hidden">
            <img
              src={FAMILY_IMG}
              alt="La facciata storica del Grappolo d'Oro"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>

        <div className="col-span-12 md:col-span-6 md:col-start-7 space-y-10">
          <div className="reveal-on-scroll">
            <p className="text-lg md:text-xl font-light leading-relaxed text-[#3D3A35]">
              {t.storia.p1}
            </p>
          </div>

          <div
            className="aspect-[16/10] overflow-hidden reveal-on-scroll"
            style={{ transitionDelay: "120ms" }}
          >
            <img
              src={DETAIL_IMG}
              alt="Tavola in cantina"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>

          <div className="reveal-on-scroll" style={{ transitionDelay: "240ms" }}>
            <p className="text-base md:text-lg font-light leading-relaxed text-[#3D3A35]">
              {t.storia.p2}
            </p>
          </div>

          <div
            data-testid="storia-aurora"
            className="reveal-on-scroll relative bg-[#B85532]/8 border-l-4 border-[#B85532] pl-6 md:pl-8 pr-5 md:pr-8 py-7 md:py-9 shadow-sm"
            style={{ transitionDelay: "320ms", backgroundColor: "rgba(184, 85, 50, 0.08)" }}
          >
            <p className="text-[10px] uppercase tracking-[0.35em] text-[#B85532] mb-3 font-medium">
              ✦ {t.storia.auroraLabel}
            </p>
            <p className="text-lg md:text-xl font-light leading-relaxed text-[#23211E]">
              {t.storia.p3}
            </p>
          </div>

          <figure
            data-testid="storia-quote"
            className="border-l border-[#B85532] pl-6 md:pl-8 py-4 reveal-on-scroll"
            style={{ transitionDelay: "440ms" }}
          >
            <blockquote className="font-serif italic text-2xl md:text-3xl leading-snug text-[#23211E]">
              {t.storia.quote}
            </blockquote>
            <figcaption className="mt-4 text-[11px] uppercase tracking-[0.3em] text-[#B85532]">
              — {t.storia.quoteAuthor}
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}
